import React from 'react'
import {
  REACT_APP_MP_URL,
  REACT_APP_ABOUT_DEFINITIONS,
  REACT_APP_DATA_SECONDARY,
  REACT_APP_CENTRALBANK
} from '../../config/settings/environment'
import AboutSiteNavButton from '../../components/Navigation/AboutSiteNavButton'
import { Table, TableCell, TableRow } from '@chilecompra/react-kit/components'
import {
  Description,
  GridContainer,
  GridItem,
  Item,
  Link,
  List,
  ListDetail,
  OrderedList,
  Root,
  SectionDivider,
  SmallItem,
  Strong,
  Subtitle,
  TableItem,
  TableList,
  Title
} from './AboutDataGoalSection.styles'

/**
 * The AboutDataGoalSection's container.
 */
const AboutDataGoalSection = () => {
  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <AboutSiteNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Origen de los datos</Title>
        </GridItem>
      </GridContainer>
      <GridContainer spacing={6}>
        <GridItem xs={12}>
          <Table>
            <TableRow enableHead>
              <TableCell width="20%">Origen</TableCell>
              <TableCell>Descripción</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Datos íntegros</TableCell>
              <TableCell>
                Son extraídos directamente de la base de datos de Mercado Público, tal como fueron ingresados por
                usuarios compradores y proveedores. Por lo tanto, las cifras presentadas corresponden a estimaciones
                proporcionadas mediante autodeclaración por parte de los usuarios de la plataforma.
                <br />
                <br />
                Por ejemplo, cabe considerar que existen órdenes de compra (OC) cuyos montos representan un contrato de
                un servicio a 3 años, no obstante éstas se registran como una transacción del año en que se emitió la
                orden de compra. En la práctica los pagos se deducirán de los presupuestos anuales durante dichos 3 años
                de la respectiva institución.
                <br />
                <br />
                En otros casos, en particular en lo que dice relación a licitaciones, el valor licitado es sólo
                estimativo registrándose a veces licitaciones con un valor de $ 1 -en las que el organismo no pudo
                efectuar la estimación- y otras con valores desproporcionadamente altos en función del producto o
                servicio a comprar.
                <br />
                <br />
                Asimismo, existen órdenes de compra con valores negativos -lo que no corresponde para una compra
                pública- dado que los organismos emiten en forma errónea dichas OC para formalizar descuentos.
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Datos procesados</TableCell>
              <TableCell>
                Son datos procesados y depurados mensualmente por la Dirección ChileCompra para generar una estimación
                del valor económico de las transacciones realizadas en Mercado Público. Estos datos son extraídos
                mensualmente desde la base de datos de Mercado Público, fueron transformados a una moneda común de forma
                que puedan ser agregados y fueron eliminadas las transacciones que presentan valores fuera de rango o
                atípicos en el campo de monto de la orden de compra.
                <br />
                <br />
                Representan una aproximación a cifras económicas y estadísticas y se encuentran sujetos a las siguientes
                variaciones:
                <TableList>
                  <TableItem>Por rectificación de los usuarios.</TableItem>
                  <TableItem>Por acción de la Dirección ChileCompra respecto de los valores atípicos.</TableItem>
                  <TableItem>
                    Por modificación de las convenciones utilizadas para efectuar estas estimaciones.
                  </TableItem>
                </TableList>
              </TableCell>
            </TableRow>
          </Table>
        </GridItem>
        <GridItem xs={12}>
          <Subtitle>Montos en transacciones</Subtitle>
          <Description>Los montos entregados como concepto de “transacción” se componen de:</Description>
          <OrderedList>
            <Item>
              Órdenes de compra que en Mercado Público se encuentran en los siguientes estados:
              <List>
                <SmallItem>Enviada a proveedor</SmallItem>
                <SmallItem>En proceso</SmallItem>
                <SmallItem>Aceptada</SmallItem>
                <SmallItem>Solicitud de cancelación</SmallItem>
                <SmallItem>Recepción conforme</SmallItem>
              </List>
              <ListDetail>
                Para mayor detalle sobras los estados de órdenes de compra puedes revisar las{' '}
                <Link href={REACT_APP_ABOUT_DEFINITIONS}>definiciones</Link>.
              </ListDetail>
            </Item>
            <Item>
              No se incluyen órdenes de compra, que aunque cumpliendo con el punto (1), pero que durante el
              procesamiento y depuración mensual de información en nuestro Datawarehouse son identificadas por tener
              errores en los montos o en el tipo de moneda al ser{'  '}
              <Strong>declaradas por las instituciones en Mercado Público</Strong>.
            </Item>
            <Item>
              No se incluyen en los montos transados ni es posible descargar, por cualquiera de los medios provistos por
              el sitio, las órdenes de compra que están asociadas a los siguientes tipos de contrato:
              <List>
                <Item>
                  Conforme a lo señalado en el artículo 3 letra e) de la Ley N°19.886 de Compras Públicas y en el
                  Decreto N°75 de 2004 del Ministerio de Obras Públicas que aprueba el Reglamento para los contratos de
                  obra pública, el Ministerio de Obras Públicas y el Ministerio de Vivienda y Urbanismo no están
                  obligados a emitir las órdenes de compra relacionadas a contratos de ejecución y concesión de obra
                  pública a través de la plataforma <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link>.
                </Item>
                <Item>
                  Es también importante mencionar que las órdenes de compra mencionadas en este punto, además del
                  precepto legal, tampoco se encuentran en Mercado Público en los estados definidos en el punto (1) como
                  válidos en el concepto de “transacción”.
                </Item>
              </List>
            </Item>
          </OrderedList>
          <SectionDivider />
        </GridItem>

        <GridItem xs={12}>
          <Subtitle>Descargas de datos</Subtitle>
          <Description>
            La descarga de datos que está disponible en el sitio se compone de la siguiente información:
          </Description>
          <OrderedList>
            <Item>
              Órdenes de compra que en Mercado Público se encuentran en los siguientes estados:
              <List>
                <SmallItem>Enviada a proveedor</SmallItem>
                <SmallItem>En proceso</SmallItem>
                <SmallItem>Aceptada</SmallItem>
                <SmallItem>Solicitud de cancelación</SmallItem>
                <SmallItem>Recepción conforme</SmallItem>
              </List>
              <ListDetail>
                Es importante destacar que por transparencia en las compras públicas, los archivos descargables de
                órdenes de compra contienen todas las órdenes de compra en los estados descritos, inclusive aquellas que
                son excluidas en el procesamiento del Datawarehouse, que es la fuente de información oficial a partir de
                la que se construyen las cifras oficiales.{' '}
                <Strong>
                  Las órdenes de compra son excluidas desde nuestro Datawarehouse por tener errores en los montos o en
                  el tipo de moneda al ser declaradas por las instituciones en Mercado Público
                </Strong>
                . Por lo tanto, al hacer cálculos sobre los datos de los archivos mencionados, las cifras pueden diferir
                de las oficiales. Para obtener el listado de aquellas órdenes de compra excluidas en los procesamientos
                del Datawarehouse puedes revisar la sección de{' '}
                <Link href={REACT_APP_DATA_SECONDARY}>datos complementarios</Link>
              </ListDetail>
            </Item>
            <Item>
              No se incluyen órdenes de compra, que aunque cumpliendo con el punto (1), pero que durante el
              procesamiento y depuración mensual de información en nuestro Datawarehouse son identificadas por tener
              errores en los montos o en el tipo de moneda al ser{'  '}
              <Strong>declaradas por las instituciones en Mercado Público</Strong>.
            </Item>
            <Item>
              Licitaciones que se encuentran en los siguientes estados dentro del sistema de información:
              <List>
                <SmallItem>Publicada</SmallItem>
                <SmallItem>Cerrada</SmallItem>
                <SmallItem>Declarada desierta</SmallItem>
                <SmallItem>Adjudicada</SmallItem>
                <SmallItem>Readjudicada</SmallItem>
                <SmallItem>Revocada</SmallItem>
                <SmallItem>Suspendida</SmallItem>
              </List>
            </Item>
          </OrderedList>
          <SectionDivider />
        </GridItem>
        <GridItem xs={12}>
          <Subtitle>Tipo de moneda</Subtitle>
          <Description>
            Los montos transados informados en el sitio de Datos Abiertos son presentados usando el tipo de moneda en
            Pesos, “CLP”, como en dólar, “USD”. La conversión a tipo de moneda dólar se realiza utilizando el valor
            mensual promedio del dólar observado. Los valores diarios del dólar observado para calcular el promedio
            mencionado, son extraídos desde los datos publicados por el Banco Central en el siguiente{' '}
            <Link href={REACT_APP_CENTRALBANK}>enlace</Link>.
            <br />
            <br />
            Para obtener los datos de conversión entre tipos de moneda descargar el archivo de la sección Registro
            hstórico de equivalencia de moneda ubicado en la sección de{' '}
            <Link href={REACT_APP_DATA_SECONDARY}>datos complementarios</Link>.
          </Description>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default AboutDataGoalSection
